import React, { useEffect } from 'react';
import { GlobalSearchV2 } from './GlobalSearchV2';
import { useUiStore } from '../../stores/uiStore';
import { PORTAL_NAV, portalKeyFromTab } from '../../constants/portals';
import { usePortalPermissions } from '../../hooks/usePortalPermissions';
import { homeCanAccess } from '../home/model/homeDestinations';
import { navigateSearchRecord, recordPortal } from './searchRecordNavigation';

export function GlobalSearchMount({ fields, role, setSelected, setFBrand }) {
  const ui = useUiStore();
  const permissions = usePortalPermissions();
  useEffect(() => {
    const select = e => {
      const { record, userId } = e.detail || {};
      if (!record || !homeCanAccess(permissions, recordPortal[record.k], userId)) return;
      navigateSearchRecord(record, {ui,setSelected,setFBrand});
    };
    window.addEventListener('home_search_record',select);
    return () => window.removeEventListener('home_search_record',select);
  },[permissions,ui,setSelected,setFBrand]);
  if (!ui.showGlobalSearch) return null;
  const activePortalLabel = PORTAL_NAV.find(p => p.key === portalKeyFromTab(ui.tab))?.label || 'Operations Hub';
  return <GlobalSearchV2 globalSearch={ui.globalSearch} setGlobalSearch={ui.setGlobalSearch}
    onClose={() => {ui.setShowGlobalSearch(false);ui.setGlobalSearch('');}}
    onSelect={sel => navigateSearchRecord(sel,{ui,setSelected,setFBrand})}
    fields={fields} role={role} activePortalLabel={activePortalLabel}/>;
}
